import {
  Attribute,
  BaseStyleId,
  Bucket,
  DateFilter,
  MapLayer,
  MapSchema,
} from "@cartographerio/atlas-map";
import { Feature } from "@cartographerio/geometry";
import { Flex, Icon, IconButton, Stack } from "@chakra-ui/react";
import React, { ReactElement, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Dict, Setter } from "../../hooks/useDict";
import InspectorPanel from "./InspectorPanel";
import FilterPanel from "./FilterPanel";

export interface InspectorSidebarProps {
  schema: MapSchema;
  layerVisibility: Dict<boolean>;
  setLayerVisibility: Setter<boolean>;
  selectedLayer: MapLayer | undefined;
  setSelectedLayer: (layer: MapLayer | undefined) => void;
  currentAttributes: Dict<Attribute>;
  currentBuckets: Dict<Dict<Bucket[]>>;
  setCurrentAttribute: (layer: MapLayer, attr: Attribute) => void;
  baseStyleId: BaseStyleId;
  setBaseStyleId: (style: BaseStyleId) => void;
  selectedFeatures: Dict<Feature[]>;
  onDateFilterChange: (filter: DateFilter) => void;
  onClearFeatureSelection: () => void;
}

export default function InspectorSidebar(
  props: InspectorSidebarProps
): ReactElement {
  const {
    schema,
    layerVisibility,
    setLayerVisibility,
    selectedLayer,
    setSelectedLayer,
    currentAttributes,
    currentBuckets,
    setCurrentAttribute,
    baseStyleId,
    setBaseStyleId,
    selectedFeatures,
    onDateFilterChange,
    onClearFeatureSelection,
  } = props;

  const [open, setOpen] = useState(window.innerWidth >= 640);
  return (
    <Stack
      position="absolute"
      pt="4"
      pl="4"
      pb="12"
      alignItems="flex-start"
      w={320}
      h="100vh"
      zIndex={3}
      spacing="4"
    >
      <Flex shrink={0}>
        <OpenButton open={open} onClick={() => setOpen(!open)} />
      </Flex>
      <Flex
        shrink={0}
        alignSelf="stretch"
        bg="rgba(255, 255, 255, 0.95)"
        borderRadius="md"
        pointerEvents="all"
        transition="transform 0.25s"
        transform={open ? undefined : "translateX(-110%)"}
      >
        <FilterPanel onChange={onDateFilterChange} />
      </Flex>
      <Flex
        shrink={1}
        alignSelf="stretch"
        pb="4"
        bg="rgba(255, 255, 255, 0.95)"
        borderRadius="md"
        overflowY="auto"
        pointerEvents="all"
        transition="transform 0.25s"
        transform={open ? undefined : "translateX(-110%)"}
      >
        <InspectorPanel
          schema={schema}
          layerVisibility={layerVisibility}
          setLayerVisibility={setLayerVisibility}
          selectedLayer={selectedLayer}
          setSelectedLayer={setSelectedLayer}
          currentAttributes={currentAttributes}
          currentBuckets={currentBuckets}
          setCurrentAttribute={setCurrentAttribute}
          baseStyleId={baseStyleId}
          setBaseStyleId={setBaseStyleId}
          selectedFeatures={selectedFeatures}
          onClearFeatureSelection={onClearFeatureSelection}
        />
      </Flex>
      {/* </Stack> */}
    </Stack>
  );
}

interface OpenButtonProps {
  open: boolean;
  onClick: () => void;
}

function OpenButton(props: OpenButtonProps) {
  const { open, onClick } = props;

  return (
    <IconButton
      icon={open ? <Icon as={FaTimes} /> : <Icon as={FaBars} />}
      aria-label={open ? "Hide inspector" : "Show inspector"}
      onClick={onClick}
    />
  );
}
